"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExceedingPrecision = exports.distilMarginInformation = void 0;
const types_1 = require("../types");
const distilMarginInformation = (direction, type) => {
    const isLong = direction === types_1.MarginOrderDirection.Long;
    const isShort = direction === types_1.MarginOrderDirection.Short;
    const isMarketOrder = type === types_1.MarginOrderType.Market;
    const isLimitOrder = type === types_1.MarginOrderType.Limit;
    const isStopOrder = type === types_1.MarginOrderType.Stop;
    return { isLong, isShort, isMarketOrder, isLimitOrder, isStopOrder };
};
exports.distilMarginInformation = distilMarginInformation;
const isExceedingPrecision = (bigString, precision) => {
    const decimalIndex = bigString.indexOf('.');
    if (decimalIndex === -1)
        return false; // No decimal part, within precision
    const decimalPlaces = bigString.length - decimalIndex - 1;
    return decimalPlaces > precision; // Check if decimal places exceed the limit
};
exports.isExceedingPrecision = isExceedingPrecision;
//# sourceMappingURL=generalUtils.js.map